import type { QuoteModuleSettings } from '../../types';

export const normalizeQuoteSettings = (data: QuoteModuleSettings): QuoteModuleSettings => {
  if (!data) {
    return {};
  }
  return data;
};
